import { notificationState } from "./atom";

export default {
  notificationState,
};
